
export function convertReceivedCoupons(result) {
  const usableCoupons = result.usable || [];
  const usedCoupons = result.used || [];
  const expiredCoupons = result.expired || [];

  usableCoupons.sort(couponSort);
  usedCoupons.sort(couponSort);
  expiredCoupons.sort(couponSort);

  const receivedCoupons = usableCoupons.map(couponInfo => {
    couponInfo.coupon['receivedType'] = 'usable';
    return couponInfo.coupon;
  }).concat(usedCoupons.map(couponInfo => {
    couponInfo.coupon['receivedType'] = 'used';
    couponInfo.coupon['usedAt'] = couponInfo.couponLog.usedAt;
    return couponInfo.coupon;
  })).concat(expiredCoupons.map(couponInfo => {
    couponInfo.coupon['receivedType'] = 'expired';
    return couponInfo.coupon;
  }));

  return receivedCoupons;
}

function couponSort(c1, c2) {
  const c1UsedAt = new Date(c1.coupon.usedEndAt).setHours(0, 0, 0, 0);
  const c2UsedAt = new Date(c2.coupon.usedEndAt).setHours(0, 0, 0, 0);

  if (c1UsedAt === c2UsedAt) {
    return c1.coupon.title.localeCompare(c2.coupon.title);
  }
  return c1UsedAt - c2UsedAt;
}


// WEBPACK FOOTER //
// ./src/utils/portalUtil.js